import styled from "styled-components";
import { Button } from "@mui/material";

export const MainWrapper = styled.div`
  padding: 25px;
  @media only screen and (max-width: 1200px) {
    padding: 10px 5px;
  }
`;

export const GamesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  background-color: ${(props) => props.theme.secondary}1a;
  padding: 4px 8px;
  border: unset;
  border-radius: 5px;
  color: ${(props) => props.theme.secondary};
  margin-top: 10px;
`;

export const BetMobileContainer = styled.div`
  display: none;
  @media only screen and (max-width: 1200px) {
    display: block;
    background-color: ${(props) => props.theme.bottomColor};
    padding: 25px;
  }
`;
export const AppLink = styled.a`
  max-width: 100%;

  img {
    max-width: 100%;
    width: 100%;
  }
`;

export const BetCouponsContainer = styled.div`
  margin-top: 25px;
  padding: 25px;
  border-radius: 5px;
  background-color: ${(props) => props.theme.backgroundColor};

  div {
    padding: 15px 0;
  }
`;

export const BetCoupons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BetLink = styled.a`
  color: ${(props) => props.theme.secondaryFont};
`;

export const UserInfosContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
  padding: 24px;
  h2 {
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 600px) {
    padding: 10px;
  }
`;
export const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const ProfileImg = styled.div`
  filter: url(#roundHex);
  width: 120px;
  position: relative;
  &::before {
    content: "";
    display: block;
    filter: url(#roundHex);
    background-image: url("https://picsum.photos/350");
    background-position: center center;
    background-size: cover;
    padding-top: 86.6%; /* 100%*cos(30) */
    clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
  &::after {
    filter: url(#roundHex);
    content: "";
    position: absolute;
    inset: -4px;
    padding: 4px;
    z-index: -1;
    display: block;
    background-color: ${(props) => props.theme.primary};
    width: 100%;
    height: 100%;
    clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
`;

export const ProfileActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EmailConfirmed = styled.p<{ isConfirmed: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  ${(props) =>
    props.isConfirmed ? `color: ${props.theme.primary}` : "color: #ff9800"}
`;

export const PersonalInfWrapper = styled.div`
  padding: 42px 0;
`;

export const PersonalInfContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.bottomColor};
  padding: 16px;
  border-radius: 5px;
  margin-top: 10px;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  @media only screen and (max-width: 600px) {
    justify-content: center;
    flex-basis: 50%;
  }
`;

export const InformationAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-evenly;
  flex-basis: 15%;
`;

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  small {
    margin-bottom: 5px;
  }
`;

export const ShowInputs = styled.div<{ canEdit: boolean }>`
  ${(props) => (props.canEdit ? "display: block;" : "display: none;")}
`;

export const ShowName = styled.div<{ canEdit: boolean }>`
  ${(props) => (props.canEdit ? "display: none;" : "display: block;")}
`;

export const WithdrawHistoryCont = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  background-color: ${(props) => props.theme.bottomColor};
  max-height: 350px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  overflow: auto;
`;

export const WithdrawItem = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  align-items: center;
  padding: 10px 24px;
`;

export const TotalWithdrawCont = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background-color: ${(props) => props.theme.selectColor};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const DashedContainer = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex: 1;
  padding: 0 10px;
`;

export const DashedInfo = styled.div<{ isPending: boolean }>`
  padding: 0 6px;
  ${(props) => (props.isPending ? "color: #ff9800" : props.theme.primary)}
`;

export const DashedGuide = styled.div`
  flex-basis: 50%;
  height: 1px;
  border: 1px dashed ${(props) => props.theme.fontColor}80;
`;

//------------------------- Modals -------------------------------
export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid ${(props) => props.theme.selectColor};
`;

export const InputLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  p {
    margin: 0;
  }
`;

export const Spacer = styled.div`
  height: 20px;
`;

export const WithdrawContainer = styled.div`
  max-width: 400px;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundColor};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const WithdrawHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-weight: bold;
  }

  span {
    cursor: pointer;
    font-size: 18px;
  }
`;

export const PlanWrapperModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 15px;
  max-width: 95%;
  max-height: 90vh;
  overflow-y: auto;
`;

export const OurPlansWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px;
  position: relative;
  border-radius: 10px;

  h2 {
    text-align: center;
    margin-bottom: 5px;
  }

  p {
    text-align: center;
    margin-bottom: 20px;
    color: ${(props) => props.theme.fontColor}80;
  }
`;

export const PlansButton = styled.button`
  width: 100%;
  border: 2px solid ${(props) => props.theme.primary};
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.backgroundColor};
  cursor: pointer;
  position: relative;

  div {
    text-align: left;

    span {
      font-size: 1.2rem;
      display: block;
      font-weight: bold;
      color: ${(props) => props.theme.fontColor};
    }

    p {
      margin: 0;
      color: ${(props) => props.theme.fontColor};
    }
  }

  &:hover {
    background-color: ${(props) => props.theme.primary}10;
  }
`;

export const DiscountTag = styled.div`
  background-color: ${(props) => props.theme.primary};
  color: white;
  padding: 5px 10px;
  border-radius: 5px;

  p {
    color: white !important;
    margin: 0;
    text-align: center;
  }
`;

export const CloseButtonCont = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
`;

export const CancelSubscriptionCont = styled.div`
  max-width: 500px;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px;
  border-radius: 10px;

  p:first-child {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  div {
    margin-top: 20px;
    border-top: 1px solid ${(props) => props.theme.selectColor};
    padding-top: 10px;

    small {
      display: block;
      margin-bottom: 5px;
      color: ${(props) => props.theme.fontColor}80;
    }

    p {
      font-weight: bold;
    }
  }
`;

export const CancelSubscriptionAction = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

export const ChangePassContainer = styled.div`
  max-width: 400px;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px;
  border-radius: 10px;
`;

export const HeaderCreditModal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  p {
    font-size: 1.5rem;
    font-weight: bold;
  }

  span {
    cursor: pointer;
    font-size: 18px;
  }
`;

export const ChangePassInputs = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const CreditCardModal = styled.div`
  max-width: 500px;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px;
  border-radius: 10px;
`;

export const CreditCardInputs = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const JoinInputs = styled.div`
  display: flex;
  gap: 15px;
`;

export const ChangePlan = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;

  div:first-child {
    p:first-child {
      font-weight: bold;
      font-size: 1.2rem;
    }

    p:last-child {
      span {
        color: ${(props) => props.theme.fontColor}80;
      }
    }
  }
`;

export const TermOfServices = styled.div`
  small {
    color: ${(props) => props.theme.fontColor}80;
  }
`;

export const TelegramButton = styled(Button)`
  display: flex;
  gap: 10px;
  background-color: #229ED9;
  color: white;
  border-radius: 5px;

  &:hover {
    background-color: #1c8ac0;
  }
`;

export const PlanContainerModal = styled.div`
  max-width: 500px;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;

  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
`;
